import React from 'react';

/** Decorative chevrons (breadcrumb separator, phone TOC). aria-hidden: never announced. */
export function ChevronRight({ className }: { className?: string }): React.ReactElement {
  return (
    <svg className={className} aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 14 14">
      <path d="M5 3.5 8.5 7 5 10.5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function ChevronDown({ className }: { className?: string }): React.ReactElement {
  return (
    <svg className={className} aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 16 16">
      <path d="M4 6 8 10 12 6" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
